import React from "react";
import { motion } from "framer-motion";
import Ebook3D from "./Ebook3D";
import { PRICE_LABEL, startCheckout } from "@/lib/checkout";
import { T } from "@/constants/testIds";
import { Button } from "./ui/button";
import { Check } from "lucide-react";

const bullets = [
  "Download imediato em PDF",
  "Leitura em celular, tablet e computador",
  "Pagamento processado via Stripe",
  "Conteúdo editorial independente",
];

export default function Purchase() {
  return (
    <section id="comprar" className="relative py-24 md:py-36 bg-black border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_right,rgba(220,38,38,0.15)_0%,transparent_60%)]" />
      </div>
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Garantir acesso</span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-display font-black leading-[0.9] tracking-[-0.03em] text-5xl md:text-7xl lg:text-8xl text-neutral-50"
          >
            Tenha acesso ao <span className="text-red-600 italic">ebook completo</span>.
          </motion.h2>
          <p className="mt-6 text-neutral-400 text-base md:text-lg max-w-xl">
            Todo o conteúdo organizado em um único material digital para você consultar quando
            quiser.
          </p>

          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-neutral-300 text-[14px]">
                <span className="mt-1 h-5 w-5 shrink-0 border border-red-600 flex items-center justify-center">
                  <Check className="h-3 w-3 text-red-500" />
                </span>
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-12 flex items-end gap-6 flex-wrap">
            <div>
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-2">
                Ebook digital — PDF
              </div>
              <div className="font-display font-black text-neutral-50 text-6xl md:text-7xl leading-none">
                {PRICE_LABEL}
              </div>
            </div>
            <Button
              data-testid={T.purchaseBuy}
              onClick={startCheckout}
              className="btn-pulse h-16 bg-red-600 hover:bg-red-700 text-white rounded-sm px-8 font-mono tracking-[0.25em] text-[12px] uppercase"
            >
              Comprar agora — {PRICE_LABEL}
            </Button>
          </div>
          <p className="mt-5 font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-600">
            Você será direcionado ao ambiente de pagamento Stripe.
          </p>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 flex items-center justify-center">
          <Ebook3D />
        </div>
      </div>
    </section>
  );
}
